<form [formGroup]="form">
  <mat-form-field class="w-full" floatLabel="auto">
    <mat-label>{{ labelKey | translate }}</mat-label>
    <input
      #inputRef
      matInput
      [appUppercase]="onlyUppercase"
      [attr.aria-label]="aria"
      [formControlName]="controlName"
      [matAutocomplete]="tnAuto"
      (blur)="onBlur()"
      (focus)="onFocus()" />

    <mat-icon matPrefix>search</mat-icon>
    <button
      *ngIf="inputControl?.value"
      mat-icon-button
      [disabled]="inputControl?.disabled"
      matSuffix
      (click)="clearInput()">
      <mat-icon class="material-icons-outlined cursor-pointer">cancel</mat-icon>
    </button>
    <mat-autocomplete
      #tnAuto="matAutocomplete"
      [displayWith]="displayFn"
      (closed)="onAutocompleteClosed()"
    >
      <mat-option
        (onSelectionChange)="onOptionSelected(option)"
        *ngFor="let option of filteredItems | async"
        [value]="option.value"
        [disabled]="option?.disabled"
        class="allow-disabled">
        {{ option.label | translate }}
      </mat-option>
    </mat-autocomplete>
    <mat-error *ngIf="inputControl?.errors">
      <ng-template [appMatErrorMessages]="inputControl" let-message>
        {{ message }}
      </ng-template>
    </mat-error>
  </mat-form-field>
</form>
